import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './Reports.css';
import { FaPlus } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const Reports = () => {
  const [tasks, setTasks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchTasks = async (isInitialLoad = false) => {
    if (isInitialLoad) {
      setLoading(true);
    }
    try {
      const response = await axios.get('/api/v1/tasks');
      if (response.data && Array.isArray(response.data.data)) {
        setTasks(response.data.data);
        setError(null);
      } else {
        if (isInitialLoad) {
          setError('Failed to fetch tasks. Please try again later.');
        }
        console.error('Invalid data format received from server.');
      }
    } catch (err) {
      if (isInitialLoad) {
        setError('Failed to fetch tasks. Please try again later.');
      }
      console.error('Error fetching tasks:', err);
    } finally {
      if (isInitialLoad) {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    fetchTasks(true);
    const interval = setInterval(() => {
      fetchTasks();
    }, 30000);

    return () => clearInterval(interval);
  }, []);

  if (loading) {
    return <div className="tasks-container"><p>Loading tasks...</p></div>;
  }

  if (error) {
    return <div className="tasks-container"><p>{error}</p></div>;
  }

  return (
    <div className="tasks-container">
      <h2>Reports</h2>
      <table className="tasks-table">
        <thead>
          <tr>
            <th>Task ID</th>
            <th>Project Name</th>
            <th>Creation Time</th>
            <th>Document Name (CN)</th>
            <th>Document Name (EN)</th>
            <th>Report</th>
          </tr>
        </thead>
        <tbody>
          {tasks.map((task) => (
            <tr key={task.id}>
              <td title={task.id}>{task.id}</td>
              <td title={task.project_nickname}>{task.project_nickname || 'Untitled'}</td>
              <td title={task.created_at}>{new Date(task.created_at).toLocaleString()}</td>
              <td title={task.doc_name_cn}>{task.doc_name_cn}</td>
              <td title={task.doc_name_en}>{task.doc_name_en}</td>
              <td>
                {!task.executed_by ? (
                  'Queuing'
                ) : parseInt(task.progress, 10) === 100 ? (
                  <a href={`/api/v1/result?uuid=${task.uuid}`} className="btn-report" target="_blank" rel="noopener noreferrer">
                    View Report
                  </a>
                ) : (
                  <div className="progress-bar-container">
                    <div className="progress-bar" style={{ width: `${task.progress}%` }}>
                      {task.progress}%
                    </div>
                  </div>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <p className="auto-refresh-note">This page automatically refreshes every 30 seconds.</p>
    </div>
  );
};

export default Reports;